// import axiosInstance from "./axiosInstance";
// import { getAccessToken } from "./getAccessTokenSilently";



// export async function postData(url: string, payload = {}) {
//   try {
//     const token = await getAccessToken();//auth
//     const response = await axiosInstance.post(url, payload,
//       {
//         headers:{
//           "Authorization": `Bearer ${token}`//auth
//         }
//       }
//     );
//     return response.data;
//   } catch (error: any) {
//     if (error.response?.status === 400) {
//       throw new Error("Bad Request");
//     } else {
//       throw new Error(error.message);
//     }
//   }
// }


import axiosInstance from "./axiosInstance";
import { getAccessToken } from "./getAccessTokenSilently";

export async function postData(url: string, payload = {}) {
  try {
    const token = await getAccessToken();

    const response = await axiosInstance.post(url, payload, {
      headers: {
        Authorization: `Bearer ${token}`, 
        "Content-Type": "application/json", 
      },
    });

    return response.data;
  } catch (error: any) {
    if (error.response?.status === 400) {
      throw new Error("Bad Request");
    } else if (error.response?.status === 401) {
      throw new Error("Unauthorized");
    } else {
      throw new Error(error.message || "Unknown error");
    }
  }
}
